/* DynamicStylesheetUtility.js */

"use strict";

const _ = require('lodash');

module.exports = () => {

    let _stylesheetTitle = 'dynamic_stylesheet';
    let _dynamicStylesheet;
    let _styleRules;

    for (let i=0; i < document.styleSheets.length; i++) {
        if (document.styleSheets[i].title === _stylesheetTitle) {
            _dynamicStylesheet = document.styleSheets[i];
            _styleRules = _dynamicStylesheet.cssRules;
        }
    }

    if (_.isUndefined(_dynamicStylesheet)) {
        let style = document.createElement('style');
            style.appendChild(document.createTextNode(''));
            style.title = _stylesheetTitle;
        document.head.appendChild(style);
        _dynamicStylesheet = style.sheet;
        _styleRules = _dynamicStylesheet.cssRules;
    }

    /**
     * Create a new CSSRule with the passed in ruleConfig style property
     * @param ruleConfig {object}
     * @private
     */
    let _appendStyleRule = (ruleConfig) => {
        _dynamicStylesheet.insertRule(ruleConfig.selector + ' { ' + ruleConfig.property + ': ' + ruleConfig.value + '; }', _styleRules.length);
    };

    /**
     * Keep any existing property/values for the existing rule but override the value for the passed in ruleConfig style property
     * @param rule {object}
     * @param index {int}
     * @param existingRule {CSSRule}
     * @private
     */
    let _overrideStyleRule = (ruleConfig, index, existingRule) => {
        let allStyleProperties = existingRule.style.cssText.split(';');
        let newStyleProperties = "";
        allStyleProperties.forEach((propertyAndValue) => {
            let property = propertyAndValue.substring(0, propertyAndValue.indexOf(':')).trim();
            if (property.length > 0) {
                if (property === ruleConfig.property) {
                    newStyleProperties += ruleConfig.property + ": " + ruleConfig.value + "; ";
                } else {
                    newStyleProperties += propertyAndValue.trim() + "; ";
                }
            }
        });
        _dynamicStylesheet.deleteRule(index);
        _dynamicStylesheet.insertRule(ruleConfig.selector + ' { ' + newStyleProperties + ' }', _styleRules.length);
    };

    /**
     * Insert the passed in property/value into the existing rule
     * @param rule {object}
     * @param index {int}
     * @param existingRule {CSSRule}
     * @private
     */
    let _insertIntoStyleRule = (ruleConfig, index, existingRule) => {
        let newStyleProperty = ruleConfig.property + ": " + ruleConfig.value + ";";
        let allStyleProperties = existingRule.style.cssText;
            allStyleProperties += " " + newStyleProperty;
        _dynamicStylesheet.deleteRule(index);
        _dynamicStylesheet.insertRule(ruleConfig.selector + ' { ' + allStyleProperties + ' }', _styleRules.length);
    };


    return {
        
        getStyleValue: (selector, styleProperty) => {
            let styleValue;
            for (let i=0; i < _styleRules.length; i++) {
                if (_styleRules[i].selectorText === selector) {
                    let allStyleProperties = _styleRules[i].style.cssText.split(';');
                    for (let j=0; j < allStyleProperties.length; j++) {
                        let propertyAndValue = allStyleProperties[j];
                        let property = propertyAndValue.substring(0, propertyAndValue.indexOf(':')).trim();
                        let value = propertyAndValue.substring(propertyAndValue.indexOf(':') + 1, propertyAndValue.length).trim();
                        if (property === styleProperty) {
                            styleValue = value;
                        }
                    }
                }
            }
            return styleValue;
        },

        setStyleValue: (selector, styleProperty, value) => {
            let foundIndex = -1;
            let foundStyleProperty = false;
            for (let i=0; i < _styleRules.length; i++) {
                if (_styleRules[i].selectorText === selector) {
                    foundIndex = i;
                    let allStyleProperties = _styleRules[i].style.cssText.split(';');
                    for (let j=0; j < allStyleProperties.length; j++) {
                        let propertyAndValue = allStyleProperties[j];
                        let property = propertyAndValue.substring(0, propertyAndValue.indexOf(':')).trim();
                        if (property === styleProperty) {
                            foundStyleProperty = true;
                            _overrideStyleRule({
                                selector: selector,
                                property: styleProperty,
                                value: value
                            }, foundIndex, _styleRules[foundIndex]);
                        }
                    }
                    if (foundStyleProperty === false) {
                        _insertIntoStyleRule({
                            selector: selector,
                            property: styleProperty,
                            value: value
                        }, foundIndex, _styleRules[foundIndex]);
                    }

                }
            }
            if (foundIndex === -1) {
                _appendStyleRule({
                    selector: selector,
                    property: styleProperty,
                    value: value
                });
            }
        },

        getDynamicStylesheet: () => {
            return _dynamicStylesheet;
        }
    };

};